import React from 'react';
import { PlaylistsPage } from './playlists/PlaylistsPage';

/** Beam on Screen → Playlists (`/#/beamonscreen/playlists`). */
export const Playlists: React.FC = () => <PlaylistsPage title="Playlists" />;
